export default __webpack_public_path__ + "static/media/hacker3-en.cc813da4.png";